import { MultiSelectV2 } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/MultiSelectV2';
import { useMapErinnerungszeitenToFristdatum } from '@/domain/mitarbeiter/shared/hooks/useMapErinnerungszeitenToFristdatum/useMapErinnerungszeitenToFristdatum';
import { useTranslation } from 'react-i18next';

/** V2-Gegenstück zu `ErinnerungsZeitenMultiSelect` (shared, auch im Anlageassistenten genutzt). */
export function ErinnerungsZeitenMultiSelectV2({
  values,
  handleChange,
  fristdatum,
}: {
  values: string[];
  handleChange: (value: string[]) => void;
  fristdatum?: string;
}) {
  const { t } = useTranslation();
  const options = useMapErinnerungszeitenToFristdatum(fristdatum);

  return (
    <MultiSelectV2
      options={options}
      values={values}
      onChange={handleChange}
      title={t('domain.mitarbeiter.fristen.erinnerungsZeit.label')}
    />
  );
}
